class Content{
    constructor(){
        this.footer = document.querySelector('.footer');

        if (this.footer){
            this.heightFooter(this.footer);
            window.addEventListener('resize', () => this.heightFooter(this.footer));
        }

    }

    heightFooter(el){
        let height = el.offsetHeight;
        document.querySelector('main#container').style.marginBottom = height+'px';
    }
}

export default Content;